@if (showLdr) {
<ds-loading></ds-loading>
}
<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicle) {
    <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>
<div class="row hdrBar">
  <div class="col-lg-6 col-md-6 mg-a">
    @if (clntDtls && clntDtls.length > 0) {
    <h1>
      Sachivalayam Dashboard @if (selectedtenantNm) {
      <span class="tntTxt">({{ selectedtenantNm }})</span>
      }
    </h1>
    }
  </div>
  @if (tntLst.length>1) {
  <div class="col-lg-3 col-md-3 mg-a" style="text-align: right">
    <span>Select ULB:</span>
    <nz-select
      class="slctBx"
      nzShowSearch
      [(ngModel)]="selectedtenant"
      (ngModelChange)="ontntSelect($event)"
      [ngModelOptions]="{ standalone: true }"
    >
      <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
      @for (t of tntLst; track t) {
      <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_dsply_nm"></nz-option>
      }
    </nz-select>
  </div>
  } @if (tntLst && tntLst.length==1) {
  <div class="col-lg-3 col-md-3 mg-a" style="text-align: right">
    <span>ULB:</span>
    <span class="disbledtxt">{{ tntLst[0].tnt_nm }}</span>
  </div>
  }
  <div class="col-lg-3 col-md-3 mg-a">
    <span>Select Date:</span>
    <nz-date-picker
      [nzDisabledDate]="disabledDate"
      [nzFormat]="dateFormat"
      [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)"
    ></nz-date-picker>
  </div>
</div>
@if (vehclesTble && vehclesTble.length>0) {
<div class="row bg-wp">
  <div class="col-lg-3 col-md-3 col-12">
    <h1 style="text-align: left">Sachivalayam Analysis</h1>
  </div>
  <div class="col-lg-9 col-md-9 col-12">
    <div class="row">
      <div
        style="
          height: 21px;
          width: 25px;
          margin: 2.5px;
          text-align: center;
          padding-top: 6px;
          color: black;
          font-weight: 600;
          font-size: 14px;
          background-color: rgb(228 230 193);
          border: 1px solid #cfb3ff;
        "
      ></div>
      <div>Trips Not assigned for Sachivalayam</div>
      <div
        style="
          height: 21px;
          width: 25px;
          margin: 2.5px;
          text-align: center;
          padding-top: 6px;
          color: black;
          font-weight: 600;
          font-size: 14px;
          background-color: rgb(160 214 213);
          border: 1px solid #cfb3ff;
        "
      ></div>
      <div>No Trips Travelled Today</div>
      <div
        style="
          height: 21px;
          width: 25px;
          margin: 2.5px;
          text-align: center;
          padding-top: 6px;
          color: black;
          font-weight: 600;
          font-size: 14px;
          background-color: rgb(230 209 193);
          border: 1px solid #cfb3ff;
        "
      ></div>
      <div>Distance travelled Less than 2 Kms</div>
    </div>
  </div>
  <div class="ds-card tbl grid">
    <app-data-grid
      [allowedPageSizes]="[100, 150, 200]"
      [totalItems]="gridTotals0"
      class="p-8"
      style="width: 100%"
      [dataSource]="vehclesTble"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="ulb wise operated Trips"
      [pageSize]="100"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
      (cellClick)="devCellclk(columnDefs, $event)"
      [cellPrepared]="bound_onCellPrepared"
    >
      <!--  -->
      <app-grid-column
        dataField="sno"
        headerCellTemplate="Sno"
        alignment="center"
      ></app-grid-column>
      <app-grid-column
        dataField="svm_nm"
        headerCellTemplate="Sachivalayam Name"
        alignment="left"
        [width]="180"
      ></app-grid-column>
      <app-grid-column
        dataField="asrt_nm"
        headerCellTemplate="Vehicle Registration Number"
        alignment="left"
        [width]="100"
      ></app-grid-column>
      <app-grid-column
        dataField="crw_nm"
        headerCellTemplate="Driver"
        alignment="left"
        [width]="80"
      ></app-grid-column>
      <app-grid-column
        dataField="ss_nm"
        headerCellTemplate="Sanitary Secratory"
        alignment="left"
        [width]="80"
      ></app-grid-column>
      <app-grid-column
        dataField="asgnd_trps"
        headerCellTemplate="Assigned Trips"
        alignment="center"
      ></app-grid-column>
      <app-grid-column
        dataField="tdy_trvl_trps"
        headerCellTemplate="Today Travelled Trips"
        alignment="center"
      ></app-grid-column>
      <app-grid-column
        dataField="tdy_trvl_dst"
        headerCellTemplate="Today Travelled Distance in Kms"
        alignment="left"
      ></app-grid-column>
      <app-grid-column caption="Trip 1" alignment="center">
        <app-grid-column
          caption="Total "
          dataField="t1_ttl"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="covered "
          dataField="t1_cvrd"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="status "
          dataField="t1_sts"
          alignment="center"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Trip 2" alignment="center">
        <app-grid-column
          caption="Total "
          dataField="t2_ttl"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="covered "
          dataField="t2_cvrd"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="status "
          dataField="t2_sts"
          alignment="center"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Trip 3" alignment="center">
        <app-grid-column
          caption="Total "
          dataField="t3_ttl"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="covered "
          dataField="t3_cvrd"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="status "
          dataField="t3_sts"
          alignment="center"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Trip 4" alignment="center">
        <app-grid-column
          caption="Total "
          dataField="t4_ttl"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="covered "
          dataField="t4_cvrd"
          format="fixedPoint"
          alignment="right"
        ></app-grid-column>
        <app-grid-column
          caption="status "
          dataField="t4_sts"
          alignment="center"
        ></app-grid-column>
      </app-grid-column>
    </app-data-grid>
  </div>
  <div class="row" style="font-weight: 400">
    &nbsp;&nbsp;Click on Sachivalayam to get Sachivalayam wise Analysis
  </div>
</div>
} @if (vehclesTble.length<=0) {
<div class="row bg-wp" style="text-align: center">
  <div>Sachivalayam Data not Provided for the ULB</div>
</div>
}
<nz-drawer
  [nzWidth]="'90%'"
  [nzClosable]="true"
  [nzVisible]="visibleDriverSldr"
  nzPlacement="right"
  nzTitle="Driver Profile"
  (nzOnClose)="visibleDriverSldr = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedDriver) {
    <app-driver-slider [driver]="selectedDriver"></app-driver-slider>
    }
  </ng-container>
</nz-drawer>
<nz-drawer
  [nzWidth]="'90%'"
  [nzClosable]="true"
  [nzVisible]="trpSldr"
  nzPlacement="right"
  nzTitle="Trips Dashboard"
  (nzOnClose)="visibleTripSldr = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedtrip) {
    <app-trips-slider [trip]="selectedtrip"></app-trips-slider>
    }
  </ng-container>
</nz-drawer>
